var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Foundations/Icons/Action/External Link/16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,8.53333333 L13.8666667,8.53333333 L13.866,3.645 L9.6,7.927 L9.6,16 L0,16 L0,6.4 L8.111,6.399 L12.36,2.133 L7.46666667,2.13333333 L7.46666667,0 L16,0 L16,8.53333333 Z M7.46666667,8.53333333 L2.13333333,8.53333333 L2.13333333,13.8666667 L7.46666667,13.8666667 L7.46666667,8.53333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-family",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-MMF---Spouse-coverage-status",
    transform: "translate(-1117.000000, -140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components/Links/External/Default",
    transform: "translate(915.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Foundations/Icons/Action/External-Link/16",
    transform: "translate(202.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "External-Link"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#34384B",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Color",
    fill: "#00A758",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.ad653e0c7e73746ab287229c53ff39de.svg";
export { ForwardRef as ReactComponent };